import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from "../SnackBar";

export const USERS_PATCH_REQUEST = 'PATCH_USERS_REQUEST';
export const USERS_PATCH_FAILURE = 'PATCH_USERS_FAILURE';
export const USERS_PATCH_SUCCESS = 'PATCH_USERS_SUCCESS';

export const patchUser = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchUserRequest());
        return axios(apiRequestOptions(apiPath.USER.PATCH, data, { params }))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(addSuccessMessage('User successfully updated'));
                dispatch(patchUserSuccess(response.data));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(patchUserFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchUserRequest = () => ({ type: USERS_PATCH_REQUEST });

const patchUserFailure = (error) => ({ type: USERS_PATCH_FAILURE, error });

const patchUserSuccess = (user) => ({ type: USERS_PATCH_SUCCESS, user });
